/*
 * @Author: your name
 * @Date: 2021-02-05 15:41:22
 * @LastEditTime: 2022-08-16 17:20:29
 * @LastEditors: xinguangding
 * @Description: In User Settings Edit
 * @FilePath: /web-platform/src/api/notice.js
 */
import request from '@/utils/request.js'

const baseUrl = process.env.VUE_APP_MESSAGE_API
const platform = process.env.VUE_APP_PLATFORM_CONSTANT
const portalUrl = process.env.VUE_APP_PORTAL_API

// 获取消息列表
export function getMessagePageApi(query) {
  return request({
    url: baseUrl + `/message/platform/${platform}/page`,
    method: 'get',
    params: query
  })
}

// 批量阅读
export function setMessageReadApi(data) {
  return request({
    url: baseUrl + `/message/platform/${platform}`,
    method: 'put',
    data
  })
}

// 全部已读
export function setMessageReadAllApi(data) {
  return request({
    url: `${baseUrl}/message/platform/${platform}/all?identity=${data.identity}`,
    method: 'put'
  })
}

// 批量删除
export function deleteMessageApi(query) {
  return request({
    url: baseUrl + `/message/platform/${platform}`,
    method: 'delete',
    data: query
  })
}

// 获取未读消息
export function getUnreadMessageApi(params) {
  return request(
    {
      url: baseUrl + `/message/platform/${platform}/unread`,
      method: 'get',
      params
    },
    false
  )
}

// 获取平台公告列表
export function getArticlesListApi(params) {
  return request(
    {
      url: `${portalUrl}/articles/page`,
      method: 'get',
      params
    },
    false
  )
}

// 获取文章详情
export function getArticlesDetailApi(articleId) {
  return request({
    url: `${portalUrl}/articles/${articleId}`,
    method: 'get'
  })
}
